// extracted by mini-css-extract-plugin
export default {"references-button":"HomePage_references-button__Ogx-x"};